import React from 'react';
import { Link, StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

export default ({ image, title, href }) => (
    <StaticQuery
        query={graphql`
            query IconQuery {
                article: file(relativePath: { eq: "icon-article.png"}) {
                    childImageSharp {
                        fixed(width: 208, height: 208, quality: 100) {
                            ...GatsbyImageSharpFixed_withWebp_tracedSVG
                        }
                    }
                }
                awards: file(relativePath: { eq: "icon-awards.png"}) {
                    childImageSharp {
                        fixed(width: 208, height: 208, quality: 100) {
                            ...GatsbyImageSharpFixed_withWebp_tracedSVG
                        }
                    }
                }
                calculator: file(relativePath: { eq: "icon-calculator.png"}) {
                    childImageSharp {
                        fixed(width: 208, height: 208, quality: 100) {
                            ...GatsbyImageSharpFixed_withWebp_tracedSVG
                        }
                    }
                }
                car: file(relativePath: { eq: "icon-car.png"}) {
                    childImageSharp {
                        fixed(width: 208, height: 208, quality: 100) {
                            ...GatsbyImageSharpFixed_withWebp_tracedSVG
                        }
                    }
                }
                home: file(relativePath: { eq: "icon-home.png"}) {
                    childImageSharp {
                        fixed(width: 208, height: 208, quality: 100) {
                            ...GatsbyImageSharpFixed_withWebp_tracedSVG
                        }
                    }
                }
                investment: file(relativePath: { eq: "icon-investment.png"}) {
                    childImageSharp {
                        fixed(width: 208, height: 208, quality: 100) {
                            ...GatsbyImageSharpFixed_withWebp_tracedSVG
                        }
                    }
                }
                retirement: file(relativePath: { eq: "icon-retirement.png"}) {
                    childImageSharp {
                        fixed(width: 208, height: 208, quality: 100) {
                            ...GatsbyImageSharpFixed_withWebp_tracedSVG
                        }
                    }
                }
                savings: file(relativePath: { eq: "icon-savings.png"}) {
                    childImageSharp {
                        fixed(width: 208, height: 208, quality: 100) {
                            ...GatsbyImageSharpFixed_withWebp_tracedSVG
                        }
                    }
                }
                terms: file(relativePath: { eq: "icon-terms.png"}) {
                    childImageSharp {
                        fixed(width: 208, height: 208, quality: 100) {
                            ...GatsbyImageSharpFixed_withWebp_tracedSVG
                        }
                    }
                }
            }
        `}
        render={data => (
            <div
                css={{
                    border: '1px solid #eee',
                    position: 'relative',
                    backgroundColor: 'white',
                }}
            >
                <Img fixed={data[image].childImageSharp.fixed} alt={image} />
                <Link
                    css={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                    }}
                    to={href}
                />
                <h2
                    css={{
                        margin: 0,
                        fontSize: 21,
                        marginBottom: 8,
                        color: '#2a2b2c',
                        textAlign: 'center',
                    }}
                >{title}</h2>
            </div>
        )}
    />
);
